"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_template_literals_1 = __importDefault(require("@netlify/classnames-template-literals"));
const SVGIcon_1 = __importDefault(require("components/shared/SVGIcon"));
const LineProgressBar_1 = __importDefault(require("components/shared/SVGProgressBar/Line/LineProgressBar"));
const SUCCESS = 'success';
const ERROR = 'error';
const PROGRESS = 'progress';
const WARNING = 'warning';
// const INFO = 'info';
const ToastComponent = ({ msg, useIcon = true, onClose, type = 'error', title, dataCy, progressPercentage = 0 }) => {
    let borderColor = '', bgColor = '', iconColor = '', iconName = '';
    switch (type) {
        case SUCCESS:
            borderColor = `var(--g-700)`;
            bgColor = 'bg-g-200';
            iconColor = `var(--g-600)`;
            iconName = 'icon-check_circle';
            break;
        case ERROR:
            borderColor = `var(--r-700)`;
            bgColor = 'bg-r-200';
            iconColor = `var(--r-600)`;
            iconName = 'icon-warning';
            break;
        case WARNING:
            borderColor = `var(--y-700)`;
            bgColor = 'bg-y-200';
            iconColor = `var(--y-600)`;
            iconName = 'icon-warning';
            break;
        case PROGRESS:
            borderColor = `var(--n-600)`;
            bgColor = 'bg-white';
            iconColor = `var(--n-600)`;
            iconName = 'icon-file_upload';
            break;
        default:
            borderColor = `var(--b-700)`;
            bgColor = 'bg-b-200';
            iconColor = `var(--b-600)`;
            iconName = 'icon-info';
            break;
    }
    const toastContentCN = (0, classnames_template_literals_1.default)(`
    flex
    py-[12px]
    pl-[12px]
    pr-[16px]
  `);
    const toastContainerCN = (0, classnames_template_literals_1.default)(`
    relative
    w-[400px]
    flex
    mt-[16px]
    rounded
    shadow-overlay
    overflow-hidden
    ${bgColor}
  `);
    return (react_1.default.createElement("div", { className: toastContainerCN, "data-cy": dataCy ? dataCy : `toast-portal-${type}`, onClick: (e) => e.stopPropagation() },
        react_1.default.createElement("div", { className: toastContentCN, style: { borderLeft: `4px solid ${borderColor}` } },
            useIcon && (react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: iconName, fillColor: iconColor, customClass: "mr-[8px]" })),
            react_1.default.createElement("div", { className: "mr-[32px]" },
                title && (react_1.default.createElement("p", { className: `typography-h400-longform text-n-900 min-h-[24px] ${type == PROGRESS && 'mb-[8px]'}` }, title)),
                type === PROGRESS ? (react_1.default.createElement("div", { className: "flex flex-row items-center" },
                    react_1.default.createElement(LineProgressBar_1.default, { transitionDuration: '0ms', progress: progressPercentage, expectedProgress: 100, width: useIcon ? 256 : 288, primaryColor: 'var(--b-500)', secondaryColor: 'var(--n-500)', fullFirst: false, height: 12, dataCy: "update-progress" }),
                    react_1.default.createElement("p", { className: "typography-h400 w-[60px] text-start ml-[8px] text-n-900" },
                        parseInt(progressPercentage.toLocaleString()),
                        "%"))) : (react_1.default.createElement("p", { className: "typography-paragraph text-n-800" }, msg))),
            react_1.default.createElement(SVGIcon_1.default, { size: 24, iconName: "icon-clear", fillColor: iconColor, customClass: "absolute top-[12px] right-[16px]", onClick: onClose }))));
};
exports.default = ToastComponent;
